module.exports = __webpack_public_path__ + "assets/b5dad4a7dd13f43be987830c8cf7a76a.png";